import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { CardGrid } from 'appSrc/components/UI';
import { ControlLink, Icon } from 'appSrc/components/UI';
import LoadingReplace from 'appSrc/components/Shards/Loading/LoadingReplace';
import style from './styles/style.module.css';


class PagifiedCardGrid extends PureComponent {
    render() {
        const { fetching, page, isMore } = this.props;

        if( fetching ) {
            return (
                <div className={ style.pagifiedCardGrid }>
                    <LoadingReplace />
                </div>
            );
        }
        return (
            <div className={ `${ style.pagifiedCardGrid } ${ this.props.className}`.trim() }>
                <div className={ style.controlBar }>
                    <ControlLink className={ style.controlLink }
                    onClick={ this.props.onPrev }
                    disabled={ page == 1 }  >
                        <Icon source='fontAwesome' icon='fas/faChevronLeft' /><span>Back</span>
                    </ControlLink>

                    <ControlLink className={ style.controlLink }
                    onClick={ this.props.onNext }
                    disabled={ !isMore }>
                        <span>Next</span><Icon source='fontAwesome' icon='fas/faChevronRight' />
                    </ControlLink>
                </div>
                <CardGrid className={ this.props.gridClass }>
                    { this.props.children }
                </CardGrid>
                <div className={ style.controlBar }>
                    <ControlLink className={ style.controlLink }
                    onClick={ this.props.onPrev }
                    disabled={ page == 1 }  >
                        <Icon source='fontAwesome' icon='fas/faChevronLeft' /><span>Back</span>
                    </ControlLink>

                    <ControlLink className={ style.controlLink }
                    onClick={ this.props.onNext }
                    disabled={ !isMore }>
                        <span>Next</span><Icon source='fontAwesome' icon='fas/faChevronRight' />
                    </ControlLink>
                </div>
            </div>
        );
    }
}
PagifiedCardGrid.propTypes = {
    page: PropTypes.number,
    isMore: PropTypes.bool,
};
PagifiedCardGrid.defaultProps = {
    page: 1,
    isMore: false,
    onPrev: ()=>{},
    onNext: ()=>{},
    gridClass: '',
    className: '',
};

export default PagifiedCardGrid;
